import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AuditTrailPage } from '@/features/audit/audit-page';

const searchSchema = z.object({
  project: z.string().optional().catch(undefined),
  actor: z.string().optional().catch(undefined),
  action: z.string().optional().catch(undefined),
  start: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  end: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/org/$orgId/audit')({
  validateSearch: searchSchema,
  component: AuditRoute,
});

function AuditRoute() {
  const { orgId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AuditTrailPage
      orgId={orgId}
      filters={{
        projectId: search.project,
        actorId: search.actor,
        action: search.action,
        start: search.start,
        end: search.end,
      }}
      onFilters={(next) =>
        void navigate({
          search: {
            project: next.projectId,
            actor: next.actorId,
            action: next.action,
            start: next.start,
            end: next.end,
          },
          replace: true,
        })
      }
    />
  );
}
